import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import Row from '../../components/shared/table/Row';
import SelectableRow from '../../components/shared/table/SelectableRow';
import Table from '../../components/shared/table/Table';
import { formatDate } from '../../utils/formatter';
import Status from '../shared/status/Status';

const VisitsTable = ({ visits, onVisitClick }) => {
  const isTabletView = useSelector((state) => state.screen.isTabletView);
  const tableRows = useMemo(
    () =>
      visits.map((visit, i) => (
        <SelectableRow key={i} onClick={() => onVisitClick(visit)}>
          {!isTabletView && <Row>{visit.id}</Row>}
          <Row>
            <Status status={visit.status} />
          </Row>
          <Row>{`${visit.createdBy.lastName} ${visit.createdBy.firstName}`}</Row>
          {!isTabletView && (
            <Row>{visit.mileage ? `${visit.mileage.toLocaleString().replace(/,/g, ' ')} км` : 'Не вказано'}</Row>
          )}
          <Row>{formatDate(visit.updatedAt)}</Row>
        </SelectableRow>
      )),
    [isTabletView, visits, onVisitClick],
  );

  return <Table columns={isTabletView ? mobileColumns : columns} data={tableRows} onRowClick={() => ({})} />;
};

const mobileColumns = [{ name: 'Статус' }, { name: 'Майстер' }, { name: 'Дата' }];

const columns = [
  { name: '№', className: 'w-[10%]' },
  { name: 'Статус', className: 'w-[20%]' },
  { name: 'Майстер', className: 'w-[30%]' },
  { name: 'Пробіг', className: 'w-[20%]' },
  { name: 'Дата', className: 'w-[20%]' },
];

export default VisitsTable;
